import { render, staticRenderFns } from "./Error2-component.vue?vue&type=template&id=57166d22&scoped=true&"
import script from "./Error2-component.vue?vue&type=script&lang=js&"
export * from "./Error2-component.vue?vue&type=script&lang=js&"
import style0 from "./Error2-component.vue?vue&type=style&index=0&id=57166d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57166d22",
  null
  
)

export default component.exports